import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const UNMATCHED_PAYMENT_TRACKING_SCHEMA = Object.freeze({
  TRANSACTION_ID: '',
});
const RECORD = generateSchema(UNMATCHED_PAYMENT_TRACKING_SCHEMA);
const KEYS: any = generateKeys(UNMATCHED_PAYMENT_TRACKING_SCHEMA);

export class UnmatchedPaymentTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.match_payment_payment_list;
  }

  get properties() {
    return this.toJS();
  }
}
